export class VersionamentoArquivo {
    caminhoArquivo: string ="";
    versaoProtocolo:number =1;
}
